module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-aiService.806a3411.png";